import React from 'react'
import { Link } from 'react-router-dom'
import T from 'i18n-react'
import route from '../stores/fetchconfig.json'

class Page404 extends React.Component {
  render () {
    return (
      <div className="background-404">
       <div className="overlay-404"></div>
       <div className="terminal-404 center-center">
        <h1> <span className="errorcode-404">404</span></h1>
         <p className="output-404"> {T.translate("error-404.pageNotFound")} </p>
         <p className="output-404"> {T.translate("error-404.tryFromHere")} <Link to={route.endpoint + "/"} className="unstyle-a error-404-link"> {T.translate("meta.home")} </Link></p>
         <p className="output-404"> {T.translate("error-404.goodLuck")} </p>
      </div>
     </div>
    )
  }
}



export default Page404



// WEBPACK FOOTER //
// ./src/components/404.js